<template>
  <page-table title="Groups I am a member of" subtitle="" :total-rows="totalRows" :per-page.sync="perPage" :current-page.sync="currentPage">
    <template v-slot:table>
      <b-table tbody-tr-class="rowClass" striped :busy="busy" :items="groups" :fields="fields" :current-page="currentPage" :per-page="perPage" :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection">
        <template #cell(anonymous_account)="data">
          <address-book-by-public-key :public-key="data.value" />
        </template>
        <template #cell(balance)="data">
          <b>{{ data.value | formatGRAM }}</b>
        </template>
        <template #cell(members)="data">
          <div v-for="member of data.item.members" :key="member[0]">
            <div class="d-flex">
              <address-book-by-public-key :public-key="member[0]" />
              &nbsp;&nbsp;{{ member[1] }}
            </div>
          </div>
        </template>
        <template #cell(action)="data">
          <toggle-switch :value="data.item.checked" @change="check($event, data.item)" />
        </template>
        <template #table-busy>
          <div class="text-center  my-5">
            <b-spinner class="align-middle" />
          </div>
        </template>
      </b-table>
    </template>
  </page-table>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressBookByPublicKey from '@/components/protected/common/AddressBookByPublicKey.vue';
import PageTable from '@/components/protected/PageTable.vue';
import ToggleSwitch from '@/components/protected/common/ToggleSwitch.vue';

export default {
  name: 'Groups',
  components: { AddressBookByPublicKey, PageTable, ToggleSwitch },
  data() {
    return {
      fields: [
        {
          key: 'group_id',
          label: 'Group ID',
          sortable: true
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'anonymous_account',
          label: 'Address Book',
          sortable: true
        },
        {
          key: 'balance',
          sortable: true
        },

        {
          key: 'members'
        },
        {
          key: 'action'
        }
      ],
      groups: [],
      busy: false,
      currentPage: 1,
      sortBy: 'name',
      sortDesc: false,
      sortDirection: 'asc',
      perPage: 5,
      totalRows: 0
    };
  },
  computed: {
    ...mapGetters(['activeGroup'])
  },
  watch: {
    groups(value) {
      this.totalRows = value.length;
    }
  },
  mounted() {
    if(!this.activeGroup){
      this.$swal({
        type: 'warning',
        title: 'Default Group Not Set',
        text: 'Please set your default group',
        timer: 5000
      })
    }
    this.getMyGroups();
  },
  methods: {
    async getMyGroups() {
      try {
        this.busy = true;
        const { data } = await this.$api.get('/groups/groups/member_of');
        this.groups = data;
        this.groups.forEach(g => g.checked = (this.activeGroup.group_id == g.group_id));
      } catch (e) {
        console.error(e);
      } finally {
        this.busy = false;
      }
    },

    async check(checked, group) {
      if (checked) {
        try {
          await this.$accounts.post('/users/default_group', {
            group_id: group.group_id
          });
          this.$store.commit('SET_ACTIVE_GROUP', group);
          this.$root.$emit('updateNotifications');
          await this.getMyGroups();
          this.$toastr.s('Default Group set', 'Success');
        } catch (e) {
          console.error(e);
          this.$toastr.e('Default Group set failed', 'Failed');
        }
      }
    }

  }
}
</script>

<style scoped>
</style>
<style>
.rowClass td {
  vertical-align: middle;
}
</style>
